import { render, staticRenderFns } from "./BookingConfirmationPage.vue?vue&type=template&id=450b1ca9&scoped=true"
import script from "./BookingConfirmationPage.vue?vue&type=script&lang=js"
export * from "./BookingConfirmationPage.vue?vue&type=script&lang=js"
import style0 from "./BookingConfirmationPage.vue?vue&type=style&index=0&id=450b1ca9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450b1ca9",
  null
  
)

export default component.exports